export default __webpack_public_path__ + "54efe90e646100b1923d3f8a6ac3e151.png";